import React from 'react';
import { useQuery } from 'react-query';
import { Redirect, RouteComponentProps, withRouter } from 'react-router-dom';
import {
  SearchEntity,
  SearchFilterType,
  SearchQuestionEntity,
} from 'v2/models';
import { mapSearchToFormData } from 'v2/utils/searchUtils';
import restFactory from 'v2/utils/restFactory';
import CreateSearch from '../CreateSearch/CreateSearch';

interface EditSearchUrlParams {
  id: string;
}

interface SearchFilterQuery {
  results: SearchFilterType[];
}

interface SearchQuestionQuery {
  results: SearchQuestionEntity[];
}

export type EditSearchOwnProps = RouteComponentProps<EditSearchUrlParams>;

const EditSearch = ({ match }: EditSearchOwnProps) => {
  const searchId = Number(match.params.id);
  const { data: search, isSuccess: searchIsSuccess } = useQuery(
    ['EditSearch_getSearchByID'],
    async () =>
      await restFactory.get<SearchEntity>(
        `/dj/api/v1/search/${searchId}/`,
        null
      ),
    { cacheTime: 0 }
  );
  const { data: filters, isSuccess: filtersIsSuccess } = useQuery(
    ['EditSearch_getFiltersBySearchID'],
    async () => {
      const queryData = await restFactory.get<SearchFilterQuery>(
        `/dj/api/v1/search/${searchId}/filters/`,
        { size: 100 }
      );
      return queryData.results;
    },
    { cacheTime: 0 }
  );

  const { data: questions, isSuccess: questionsIsSuccess } = useQuery(
    ['EditSearch_getQuestionsBySearchID'],
    async () => {
      const queryData = await restFactory.get<SearchQuestionQuery>(
        `/dj/api/v1/search/${searchId}/questions/`,
        { size: 100 }
      );
      return queryData.results;
    },
    { cacheTime: 0 }
  );

  if (
    !search ||
    !filters ||
    !questions ||
    !searchIsSuccess ||
    !filtersIsSuccess ||
    !questionsIsSuccess
  ) {
    return null;
  }

  const searchToEdit = mapSearchToFormData({
    ...search,
    filters,
    questions,
  });
  if (!searchToEdit) {
    return <Redirect to="/" />;
  }
  return <CreateSearch searchToEdit={searchToEdit} />;
};

export default withRouter(EditSearch);
